import { trackEvent } from '@/utils/analytics/useAnalytics'

import { Box, Tab, TabList, TabPanel, TabPanels, Tabs } from '@chakra-ui/react'

import { IncidentType } from '@/graphql/generated/schemas'
import { BUTTON_PRESS } from '@/utils/analytics'

import { EventFiltersI } from '../types/types'
import {
  DEVICES_TAB_EVENT,
  FACILITIES_TAB_EVENT,
  INCIDENT_TAB_EVENT,
  getMixpanelEventData,
} from '../utils/utils'
import { EventFeed } from './EventFeed'
import { TraceLogHeader } from './TraceLogHeader'

// The 112px here are the Header, Tab and padding height values
export const TRACE_LOG_PANEL_HEIGHT = 'calc(100vh - 135px)'

export const TraceLogContent = ({ incident }: EventFiltersI) => {
  // Show Incident tab ONLY for Tailgating incidents with associated events
  const isTailgatingIncident = incident?.type === IncidentType.Tailgating
  const hasIncidentEvents =
    isTailgatingIncident && incident?.eventExternalIds?.length > 0

  const handleMixPanelEvent = (tabName: string) => {
    trackEvent(
      `${BUTTON_PRESS} ${tabName} tab - trace logs`,
      getMixpanelEventData(incident)
    )
  }

  return (
    <Box>
      <TraceLogHeader />
      <Tabs
        borderColor='transparent'
        defaultIndex={hasIncidentEvents ? 0 : undefined}
        fontWeight='500'
        isFitted
        isLazy
        w='100%'
      >
        <TabList>
          {hasIncidentEvents && (
            <Tab
              _selected={{
                color: 'components.tab.active',
                borderBottomColor: 'components.tab.active',
                opacity: 1,
              }}
              data-testid='incident-tab'
              onClick={() => handleMixPanelEvent(INCIDENT_TAB_EVENT)}
              opacity={0.4}
            >
              <Box
                alignItems='center'
                display='inline-flex'
                paddingBottom='8px'
                paddingTop='12px'
              >
                Incident
              </Box>
            </Tab>
          )}
          <Tab
            _selected={{
              color: 'components.tab.active',
              borderBottomColor: 'components.tab.active',
              opacity: 1,
            }}
            onClick={() => handleMixPanelEvent(DEVICES_TAB_EVENT)}
            opacity={0.4}
          >
            <Box
              alignItems='center'
              display='inline-flex'
              paddingBottom='8px'
              paddingTop='12px'
            >
              Device
            </Box>
          </Tab>
          <Tab
            _selected={{
              color: 'components.tab.active',
              borderBottomColor: 'components.tab.active',
              opacity: 1,
            }}
            onClick={() => handleMixPanelEvent(FACILITIES_TAB_EVENT)}
            opacity={0.4}
          >
            <Box
              alignItems='center'
              display='inline-flex'
              paddingBottom='8px'
              paddingTop='12px'
            >
              Facility
            </Box>
          </Tab>
        </TabList>
        <TabPanels px='0'>
          {hasIncidentEvents && (
            <TabPanel px='0' py='0px'>
              <EventFeed
                filters={{ deviceId: incident?.devices?.[0]?.id }}
                incident={incident}
                showOnlyIncidentRelatedEvents={true}
              />
            </TabPanel>
          )}
          <TabPanel px='0' py='0px'>
            <EventFeed
              filters={{ deviceId: incident?.devices?.[0]?.id }}
              incident={incident}
            />
          </TabPanel>
          <TabPanel px='0' py='0px'>
            <EventFeed
              filters={{ facilityId: incident?.facility?.id }}
              incident={incident}
            />
          </TabPanel>
        </TabPanels>
      </Tabs>
    </Box>
  )
}
